import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface CountryModeResult {
  mode: 'wallet' | 'explorer';
  country?: string;
  isLoading: boolean;
  isWalletMode: boolean;
}

export const useCountryMode = (): CountryModeResult => {
  const [mode, setMode] = useState<'wallet' | 'explorer'>('explorer');
  const [country, setCountry] = useState<string | undefined>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCountryMode = async () => {
      try {
        const { data, error } = await supabase.functions.invoke('admin', {
          body: { action: 'get_ios_app_mode' }
        });

        if (error) {
          console.error('Error fetching country mode:', error);
          setIsLoading(false);
          return;
        }

        if (data?.success) {
          setMode(data.mode || 'explorer');
          setCountry(data.country);
        }
      } catch (err) {
        console.error('Failed to fetch country mode:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCountryMode();
  }, []);

  return {
    mode,
    country,
    isLoading,
    isWalletMode: mode === 'wallet'
  };
};
